import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
  initialState,
} from '../../utils/redux';

import * as documentsUploadReq from './documents-upload-req';
import * as documentsDeleteReq from './documents-delete-req';

export const consts = createReqConsts('dependentForm', 'documents-fetch-list', [
  'RESET',
]);
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'dependent_registration',
  type: 'get',
  slug: [
    'assignments',
    {
      type: 'payload',
      selector: ['id'],
    },
    'documents',
  ],
});

const defaultReqReducer = createReqReducer(consts);

const rootState = { ...initialState, list: [] };

export default (state = rootState, action) => {
  switch (action.type) {
    case documentsUploadReq.consts.SUCCEED: {
      return {
        ...state,
        list: [...state.list, action.payload],
      };
    }

    case documentsDeleteReq.consts.DELETE_SUCCESS: {
      return {
        ...state,
        list: state.list.filter(({ id }) => id !== action.payload),
      };
    }

    case consts.RESET: {
      return rootState;
    }
    default: {
      return defaultReqReducer(state, action);
    }
  }
};



// WEBPACK FOOTER //
// ./src/redux/dependentForm/documents-fetch-list-req.js